import Component from '../core/Component';
import {queryAll} from '../utils/dom'

export default class Tabs extends Component {
    prepare() {
        this.menu_items = queryAll('.technology-menu li a,.technology-menu__accordion-button', this.element);
        this.panels = queryAll('.section-technologies__panel-content', this.element);

        this.panels[0].classList.add('is-active'); //nastaví první panel viditelný
        this.menu_items[0].classList.add('is-active'); //nastaví první odkaz aktivní

        this.menu_items.forEach(item => {
            item.addEventListener("click", ::this.handleClick)
        });
    }

    handleClick(e) {
        let item = e.target, //získáme A na které klikáme
            item_target = item.getAttribute("href"); //získáme odkaz


        this.panels.forEach(panel => {
            panel.classList.remove("is-active");
        })

        this.menu_items.forEach(item => {
            item.classList.remove("is-active");
        })

        document.querySelector(item_target).classList.add('is-active'); //přiřadí is-active ke zvolenému tabu
        item.classList.add("is-active"); //přiřadí is-active ke kliknuté položce
    }


}


// WEBPACK FOOTER //
// ./components/Tabs.js